import { where } from "firebase/firestore";
import { getAuth, signOut } from "firebase/auth";

import {
  addDocument,
  getDocuments,
  deleteDocument,
  updateDocument,
  collectionChangeListener,
  setDocument,
} from './firebase/firestore';
import { logout, create2Account } from './firebase/auth';
import { message } from '../Utils';
import { secondApp } from './firebase/firebaseConfig';

const ORDER_COLLECTION = "Order";
const SUBMITTED_ORDERS_COLLECTION = "SubmittedOrders";
const USER_COLLECTION = "Users";
const CONFIG_COLLECTION = "Config";

export const addOrder = (data) => {
  return addDocument(ORDER_COLLECTION, data);
}

export const getOrders = (options) => {
  return getDocuments(ORDER_COLLECTION, 'place', options);
}

export const getActiveOrders = () => {
  return getDocuments(ORDER_COLLECTION, 'name', { where: where("active", "==", true) });
}

export const deleteOrder = (docId) => {
  return deleteDocument(ORDER_COLLECTION, docId);
}

export const updateOrder = (docId, data) => {
  return updateDocument(ORDER_COLLECTION, docId, data);
}

export const submitOrder = (data) => {
  return addDocument(SUBMITTED_ORDERS_COLLECTION, data)
}

export const listenerSubmitNewOrder = () => {
  return collectionChangeListener(SUBMITTED_ORDERS_COLLECTION);
}

export const addAccount = (email, password, admin) => {
  const auth = getAuth(secondApp);
  return create2Account(auth, email, password).then((userCredential) => {
    signOut(auth);
    return setDocument(USER_COLLECTION, userCredential.user.uid, { email, admin });
  });
}

export const getAccounts = (options) => {
  return getDocuments(USER_COLLECTION, 'email', options);
}

export const userLogout = (navigate) => {
  logout().then(() => {
    localStorage.clear();
    navigate('/login', { replace: true });
  }).catch((error) => {
    message.error(error.message);
  });
}

export const deleteAccount = (docId) => {
  return deleteDocument(USER_COLLECTION, docId);
}

export const addConfig = (data) => {
  return addDocument(CONFIG_COLLECTION, data);
}

export const getConfig = (options) => {
  return getDocuments(CONFIG_COLLECTION, 'type', options);
}

export const updateConfig = (docId, data) => {
  return updateDocument(CONFIG_COLLECTION, docId, data);
}